import request from '@/utils/request'


export function getMenu(data){
    return request({
        url: '/user/showUser.do',
        method: 'post',
        data
    })
}
// export function getMenumaker(data){
//     return request({
//         url: '/user/showMaker.do',
//         method: 'post',
//         data
//     })
// }
//企业信息获取
export function orgTempuserBind(data){
    return request({
        url: '/orgTemp/info/userBind',
        method: 'get',
        formData:true,
        data
    })
}
export function forgetPasswordOnLogin(data){
    return request({
        url: '/enterprise/initphone.do',
        method: 'post',
        data
    })
}
export function getBaiduIsTaskBan(data){
    return request({
        url: '/baiduModeration/isBan',
        method: 'get',
        formData:true,
        data
    })
}
export function getBaiduCheckText(data){
    return request({
        url: '/baiduModeration/checkText',
        method: 'post',
        formData:true,
        data
    })
}
export function getBaiduCheckImage(data){
    return request({
        url: '/baiduModeration/checkImage',
        method: 'post',
        formData:true,
        data
    })
}
export function userRegistRelation(data){
    return request({
        url: '/userRightsRegistRelation/userRegistRelation.do',
        method: 'post',
        formData:true,
        data
    })
}
export function violationRecords(data){
    return request({
        url: '/baiduModeration/violationRecords',
        method: 'post',
        formData:true,
        data
    })
}
export function pointAmount(data){
    return request({
        url: '/pageButtomRegistRecord/pointAmount',
        method: 'post',
        data
    })
}
export function updateUserPassword(data){
    return request({
        url: '/user/updatepass.do',
        method: 'post',
        data
    })
}

export function switchUserDuty(data){
    return request({
        url: '/user/showDuty.do',
        method: 'post',
        data
    }) 
}

export function updateUserDuty(data){
    return request({
        url: '/user/changeDuty.do',
        method: 'post',
        data
    }) 
}
export function updateUserzhiwu(data){
    return request({
        url: '/user/updateLeyeUser.do',
        method: 'post',
        data
    }) 
}
export function userlogout(data){
    return request({
        url: '/user/logout',
        method: 'post',
        data
    }) 
}
export function wechatcode(data){
    return request({
        url: '/wechat/QRcode',
        method: 'post',
        formData:true,
        data
    }) 
}
export function wechaturl(data){
    return request({
        url: '/wechat/getUrl',
        method: 'post',
        formData:true,
        data
    }) 
}
export function getRongYunInitMessage(data){
    return request({
        url: '/user/getRongYunInitMessage',
        method: 'get',
        data
    }) 
}
// 系统通知未读总数
export function getUnreadMessage(data){
    //通知
    return request({
        url: '/message/getUnreadMessage',
        formData:true,
        method: 'get',
        data
    })
}
export function getUserMessage(data){
    //通知
    return request({
        url: '/message/getUserMessage',
        formData:true,
        method: 'get',
        data
    })
}
export function updateStatus(data){
    //修改通知
    return request({
        url: '/message/updateStatus',
        method: 'post',
        data
    })
}
// export function getNewsList(data){
//     //通知
//     return request({
//         url: '/sessionNews/getNewsList',
//         method: 'get',
//         type:'xcx',
//         data
//     })
// }

